import { EntityWalletTransactionType } from './EntityWalletTransactionType';
import { PaymentMethod } from './PaymentMethod';
export class SubmitPaymentModel {
    duePaymentIds: any[] = new Array();
    transactionType: EntityWalletTransactionType;
    paymentMethod: PaymentMethod;
    totalPaymentAmount: number;
}
